import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { classNames, format } from '@dt/fe-utils'
import { payPlanMobx } from '@mobxStore'

interface IProps {
  option: IAmountTipOption;
  onSelected?: () => void;
}

const AmountTipItem: FC<IProps> = ({ option, onSelected }) => {
  const selected = payPlanMobx.selectedTipOption?.type === 'amount' &&
    payPlanMobx.selectedTipOption?.amount === option.amount

  const onClick = () => {
    payPlanMobx.selectTipOption(option)
    onSelected && onSelected()
  }

  return (
    <li className={classNames('select-tip-item', { selected })} data-cypid='amountTipItem' onClick={onClick}>
      <span className='amount'>{format.toPrice(option.amount)}</span>
      <i className={classNames('iconfont', selected ? 'icon-checked' : 'icon-circle')} />
    </li>
  )
}

export default observer(AmountTipItem)
